angular.module('MyHippoProducer.Controllers').directive('discountsSection', function () {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'pages/policy-details/sections/discounts/discounts.html',
    };
});
